import EyeClosedIcon from '@/assets/svg/ui-elements/eye-closed.svg';
import EyeIcon from '@/assets/svg/ui-elements/eye-outline.svg';

import { SelectionIcon } from './assets-table.styled';

interface PerformancePositionSelectionIconProps {
  active: boolean;
  dimmed: boolean;
}

export const PerformancePositionSelectionIcon = ({
  active,
  dimmed,
}: PerformancePositionSelectionIconProps) => (
  <SelectionIcon $active={active} data-selected={active} aria-hidden="true">
    {dimmed ? <EyeClosedIcon /> : <EyeIcon />}
  </SelectionIcon>
);
